export default {
  name: 'document',
  uniqKey: '_id',
  crudMapping: {
    // create: 'createDocument',
    readMany: 'documents',
    readOne: 'document',
    update: 'updateDocument',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Document',
      type: 'object',
      required: ['title', 'slug'],
      properties: {
        title: {
          type: 'string',
          title: 'Document Title',
        },
        slug: {
          type: 'string',
          title: 'URL Slug',
        },
        file: {
          type: 'string',
          title: 'File',
          hint: 'Upload your file',
        },
      },
    },
    uiSchema: {
      file: {
        'ui:widget': 'fileWidget',
      },
      slug: {
        'ui:readonly': true,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/document.js